var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-11 gap-0 auto-cols-max"},[_c('TeamBoard',{staticClass:"col-span-5",attrs:{"color":"red","side":"left"}}),_c('Timer'),_c('TeamBoard',{staticClass:"col-span-5",attrs:{"color":"blue","side":"right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }